import { Actions } from "./actions";
import { IO_ERROR, ErrorAction } from "../../../ajax/state/actions";
import { State } from "./state";
import { fromServer, toServer } from "../filters";
import initial from "./state.initial";
import { Utils } from "../../../utils";
import { ReducerActions, createReducerActions } from "../../../Store/reducer";

import { COMMANDS } from "../../../shared";

type TActions =
  | Actions.GetRequest
  | Actions.PostRequest
  | Actions.GetResponse
  | Actions.PostResponse
  | Actions.Edit
  | ErrorAction;

const actions: ReducerActions<State.Props, TActions> = {
  [Actions.REQUEST_GET]: getRequest,
  [Actions.REQUEST_POST]: postRequest,
  [Actions.RESPONSE_GET]: getResponse,
  [Actions.RESPONSE_POST]: postResponse,
  [Actions.EDIT]: edit,
  [IO_ERROR]: error
};

export default createReducerActions(actions, initial);

function getRequest(state: State.Props): State.Props {
  return { ...state, loadingGet: true };
}

function postRequest(
  state: State.Props,
  action: Actions.PostRequest
): State.Props {
  if (action.exe) {
    let mask: COMMANDS[] = "xxxxxxxx".split("") as COMMANDS[];
    mask[action.exe.idx] = action.exe.cmd;
    Object.assign(action.data, toServer(action.data), { mask: mask.join("") });
  } else {
    Object.assign(action.data, toServer(action.data));
  }
  return { ...state, loadingPost: true };
}

function getResponse(
  state: State.Props,
  action: Actions.GetResponse
): State.Props {
  return {
    ...state,
    status: "OK",
    data: fromServer(action.data.flags),
    form: fromServer(action.data.flags),
    submitRequired: false,
    loadingGet: false
  };
}

function postResponse(state: State.Props): State.Props {
  return { ...state, loadingPost: false };
}

function edit(state: State.Props, action: Actions.Edit): State.Props {
  let form = Object.assign({}, state.form, action.data);
  let diff = !!Object.keys(Utils.diff(form, state.data)).length;
  return { ...state, ...{ form }, ...{ submitRequired: diff } };
}

function error(state: State.Props): State.Props {
  return { ...state, loadingPost: false, loadingGet: false };
}
